export const IgniteAdmins = [
  "h.srinivasan",
  "varsha.a.tyagi",
  "uma.rani.battu",
  "ankur.e.mishra",
  "arpita.m.singh",
  "aluru.akash",
  "nikita.apte",
  "shubham.i.tyagi",
  "jeevadharani.ramanan",
  "potnuru.sandeep",
  "srikanth.narabathoju",
  "dhaval.atul.pantojee",
  "azeem.a.pinjari",
  "saurabh.d.kaushik",
  "a.kaur.g.bhatia",
  "jeevan.shetty",
  "sindhu.s.nambiar",
  "mohana.krishnaveni",
  "ashima.thareja",
  "mahamad.h.l.pirjade",
  "srinjay.fadikar"
];
